import myRequest from '@/services/myRequest';

// 添加敏感词
export async function queryContentByKeyWords(params) {
  return myRequest('post', '/titleCollege/queryContentByKeyWords', params, {
    requestType: 'json',
  });
}
